import Select, { StylesConfig } from "react-select";

export type AgSelectOption = {
  label: string;
  value: string;
};

type AgSelectProps = {
  value?: string;
  options: AgSelectOption[];
  onChange: (value: string) => void;
  placeholder?: string;
  isDisabled?: boolean;
  isClearable?: boolean;
  menuPortalTarget?: HTMLElement | null;
};

const styles: StylesConfig<AgSelectOption, false> = {
  control: (base) => ({
    ...base,
    minHeight: 38,
    borderColor: "#ced4da",
    boxShadow: "none",
    "&:hover": { borderColor: "#adb5bd" },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 2147483641,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 2147483641,
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: 220,
  }),
};

const AgSelect = ({
  value,
  options,
  onChange,
  placeholder = "Select...",
  isDisabled = false,
  isClearable = false,
  menuPortalTarget = typeof document !== "undefined" ? document.body : null,
}: AgSelectProps) => {
  const selected =
    value && options.some((o) => o.value === value)
      ? options.find((o) => o.value === value) ?? null
      : null;

  return (
    <Select<AgSelectOption>
      options={options}
      value={selected}
      onChange={(opt) => onChange(opt?.value || "")}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isClearable={isClearable}
      menuPortalTarget={menuPortalTarget}
      menuPosition="fixed"
      styles={styles}
      classNamePrefix="ag-select"
    />
  );
};

export default AgSelect;
